// My tasks (26 October 2026): what Zeus has been asked to do again and again.
export default {
  titre: 'My tasks',
  sousTitre: 'What Zeus does for you, on schedule',
  vide: {
    titre: 'No task yet',
    texte: 'Ask Zeus for regular follow-up: “listen to this format every day and give me a summary”. He proposes it here.',
  },
  choisir: 'Pick a task to read its summaries and adjust it.',
  statut: { proposee: 'Proposed', active: 'Active', pause: 'Paused' },
  nature: {
    ecoute_format: 'Listening to a format',
    ecoute_sujet: 'Listening to a topic',
    sonar: 'Question to the panel',
    brief: 'The brief',
    radar: 'The Radar',
  },
  cadence: { quotidienne: 'Every day', hebdomadaire: 'Every week', mensuelle: 'Every month' },
  enCours: 'Run in progress',
  prochaine: 'Next summary: {quand}',
  consigne: 'What you want to read:',
  activer: 'Activate',
  reprendre: 'Resume',
  pause: 'Pause',
  maintenant: 'Run now',
  supprimer: 'Delete',
  confirmer: 'Delete this task?',
  oui: 'Yes, delete',
  non: 'Cancel',
  reglages: { cadence: 'Frequency', heure: 'Summary ready at', email: 'Also receive by e-mail' },
  resumes: 'Summaries',
  aucunResume: 'No summary yet: activate the task.',
  aucunResumeActive: 'The first summary arrives at the next run.',
}
